import React, { useState } from "react";
import Icon from "components/AppIcon";


const alerts = [
  { id: 1, type: "error", icon: "AlertCircle", title: "Payment Overdue", desc: "23 members have payments overdue by 7+ days", action: "Review", color: "var(--color-error)" },
  { id: 2, type: "warning", icon: "Clock", title: "Expiring Soon", desc: "41 memberships expire within next 7 days", action: "Notify", color: "var(--color-warning)" },
  { id: 3, type: "warning", icon: "UserMinus", title: "Churn Risk", desc: "18 members haven't checked in for 14+ days", action: "Engage", color: "var(--color-warning)" },
  { id: 4, type: "success", icon: "TrendingUp", title: "Revenue Milestone", desc: "March revenue exceeded target by 12.4%", action: "View", color: "var(--color-success)" },
  { id: 5, type: "info", icon: "RefreshCw", title: "Renewal Opportunity", desc: "67 memberships eligible for annual upgrade", action: "Upsell", color: "var(--color-primary)" },
];

export default function PerformanceAlerts() {
  const [dismissed, setDismissed] = useState([]);
  const visible = alerts?.filter(a => !dismissed?.includes(a?.id));

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-[var(--radius-md)] p-4 shadow-[var(--shadow-sm)]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-[var(--color-foreground)] font-[var(--font-heading)]">Performance Alerts</h3>
        <span className="bg-[var(--color-error)]/10 text-[var(--color-error)] text-xs font-medium px-2 py-0.5 rounded-full font-[var(--font-caption)]">
          {visible?.filter(a => a?.type === "error" || a?.type === "warning")?.length} Active
        </span>
      </div>
      <div className="space-y-2.5">
        {visible?.map(alert => (
          <div key={alert?.id} className="flex items-start gap-3 p-3 rounded-[var(--radius-sm)] bg-[var(--color-muted)]/50 group">
            <div className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ backgroundColor: `${alert?.color}18` }}>
              <Icon name={alert?.icon} size={14} color={alert?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-[var(--color-foreground)] font-[var(--font-caption)]">{alert?.title}</p>
              <p className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)] mt-0.5 line-clamp-2">{alert?.desc}</p>
            </div>
            <div className="flex items-center gap-1 flex-shrink-0">
              <button className="text-xs font-medium font-[var(--font-caption)] px-2 py-1 rounded transition-colors hover:bg-[var(--color-border)]" style={{ color: alert?.color }}>
                {alert?.action}
              </button>
              <button onClick={() => setDismissed(p => [...p, alert?.id])} className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-[var(--color-border)]">
                <Icon name="X" size={12} color="var(--color-muted-foreground)" />
              </button>
            </div>
          </div>
        ))}
        {visible?.length === 0 && (
          <div className="text-center py-6">
            <Icon name="CheckCircle2" size={32} color="var(--color-success)" />
            <p className="text-xs text-[var(--color-muted-foreground)] mt-2 font-[var(--font-caption)]">All clear! No active alerts.</p>
          </div>
        )}
      </div>
    </div>
  );
}